import { collection, query, where, getDocs, orderBy } from "firebase/firestore";
import { db } from "./firebase";

const today = () => new Date().toISOString().split("T")[0];

/**
 * Proactively reads future and current trips + their segments from Firestore.
 * Because IndexedDB persistence is enabled, this warms the local cache so the
 * app works offline without the user having to manually visit each trip first.
 *
 * Call this once after the user signs in (fire-and-forget — no need to await).
 */
export async function warmCache(uid) {
  try {
    const todayStr = today();

    // Fetch all trips for this user
    const tripsSnap = await getDocs(
      query(collection(db, "trips"), where("memberIds", "array-contains", uid))
    );

    const relevantTrips = tripsSnap.docs.filter((d) => {
      const data = d.data();
      // Keep trips that are upcoming or currently active (no end date = always relevant)
      return !data.endDate || data.endDate >= todayStr;
    });

    // Fetch all segments for relevant trips in parallel
    await Promise.all(
      relevantTrips.map((tripDoc) =>
        getDocs(
          query(
            collection(db, "trips", tripDoc.id, "segments"),
            orderBy("date")
          )
        )
      )
    );

    console.log(`[cache] Warmed ${relevantTrips.length} upcoming/active trips`);
  } catch (e) {
    // Non-fatal — just means offline mode won't be pre-warmed this session
    console.log("[cache] Warm failed (likely offline already):", e.message);
  }
}
